import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ComponentButton.css';
const ComponentButton = ({ id, title, name, onClick, isLoading, classes, isDisabled, isSubmit, isAlert, children }) => {
    const className = classNames({
        button: true,
        [classes]: true,
        redalert: isAlert,
        'cursor-pointer': true,
        'button--loading': isLoading
    });
    const iconStyle = { opacity: isLoading ? 1 : 0 };
    const textStyle = { opacity: isLoading ? 0 : 1 };
    return (_jsxs("button", Object.assign({ tabIndex: 0, id: id, type: isSubmit ? 'submit' : 'button', name: name, className: `relative ${className}`, onClick: onClick, disabled: isDisabled }, { children: [_jsx("span", Object.assign({ className: 'pointer-events-none absolute top-0 left-0 text-center w-full h-full flex justify-center items-center' }, { children: _jsx("span", { className: 'loader-on', style: iconStyle }) })), title && _jsx("span", Object.assign({ style: textStyle }, { children: title })), !title && _jsx("span", Object.assign({ style: textStyle }, { children: children }))] })));
};
ComponentButton.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    onClick: PropTypes.func,
    isLoading: PropTypes.bool,
    classes: PropTypes.string,
    isDisabled: PropTypes.bool,
    isAlert: PropTypes.bool,
    isSubmit: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};
ComponentButton.defaultProps = {
    id: '',
    name: '',
    title: false,
    isLoading: false,
    classes: '',
    isDisabled: false,
    isSubmit: false,
    isAlert: false,
    children: null
};
export default ComponentButton;
